import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustStats } from '../components/TrustStats';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { ServiceArea } from '../components/ServiceArea';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <main data-id="element-312">
      <HeroSection data-id="element-313" />
      <TrustStats data-id="element-314" />
      <AboutSection data-id="element-315" />
      <ServicesSection data-id="element-316" />
      <WhyChooseUs data-id="element-317" />
      <Testimonials data-id="element-318" />
      <ServiceArea data-id="element-319" />
      <CTABanner data-id="element-320" />
    </main>;
}